import { MatchFormat } from "../matchTypes";

export interface PlayerRoleIds {
  captainId?: string | null;
  viceCaptainId?: string | null;
  keeperId?: string | null;
}

export interface PlayerRoleFlags {
  isCaptain: boolean;
  isViceCaptain: boolean;
  isWicketkeeper: boolean;
}

export function viceCaptainAvailable(format: MatchFormat): boolean {
  return true;
}

export function getPlayerRoleFlags(
  playerId: string,
  format: MatchFormat,
  ids: PlayerRoleIds
): PlayerRoleFlags {
  return {
    isCaptain: ids.captainId === playerId,
    isViceCaptain: viceCaptainAvailable(format) && ids.viceCaptainId === playerId,
    isWicketkeeper: ids.keeperId === playerId,
  };
}
